import apiService from './api';

export interface CreditBalanceResponse {
  total_credits_balance: number;
  credit_bonus: number;
  expiry_date: string | null;
  is_low_credit: boolean;
  is_expiring_soon: boolean;
  is_expired: boolean;
}

export interface TopupOptionResponse {
  id: number;
  tier_amount: number | null;
  is_manual_entry: boolean;
  rate_per_credit: number;
  min_threshold: number | null;
  price: number | null;
}

export interface ModulePricingResponse {
  module_id: number;
  module_code: string;
  credit_cost: number;
  inr_equivalent: number;
}

export interface CreditPurchaseRequest {
  tier_id: number | null;
  manual_amount: number | null;
  payment_method?: string;
}

export interface CreditTransactionResponse {
  ledger_id: number;
  user_id: string;
  subscription_id: number | null;
  module_id: number | null;
  module_code: string | null;
  transaction_type: string;
  credit_amount: number;
  inr_amount: number | null;
  reference_id: string | null;
  description: string | null;
  created_at: string;
}

export const creditService = {
  async getBalance(): Promise<CreditBalanceResponse> {
    return apiService.get<CreditBalanceResponse>('/credits/balance');
  },

  async getTopupOptions(): Promise<TopupOptionResponse[]> {
    return apiService.get<TopupOptionResponse[]>('/credits/topup-options');
  },

  async getModulePricing(): Promise<ModulePricingResponse[]> {
    return apiService.get<ModulePricingResponse[]>('/credits/module-pricing');
  },

  async purchaseCredits(payload: CreditPurchaseRequest): Promise<any> {
    return apiService.post<any>('/credits/purchase', {
      tier_id: payload.tier_id,
      manual_amount: payload.manual_amount,
      payment_method: payload.payment_method || 'UPI',
    });
  },

  async getUsageHistory(page: number = 1, pageSize: number = 10): Promise<CreditTransactionResponse[]> {
    return apiService.get<CreditTransactionResponse[]>(
      `/credits/usage-history?page=${page}&page_size=${pageSize}`
    );
  },
};
